import React from 'react';

import { useReportItemsFilter } from 'src/hooks/reports';

import { VERIFICATION_REQUESTS_TABLE_COLUMNS_VERIFIER_ADMIN } from '../constants';

import { VerificationRequestsInnerTable } from './VerificationRequestsInnerTable';

export const VerificationRequestsTableVerifierAdmin: React.FC = () => {
  const { filter } = useReportItemsFilter();

  return (
    <VerificationRequestsInnerTable
      columns={VERIFICATION_REQUESTS_TABLE_COLUMNS_VERIFIER_ADMIN}
      filter={filter}
    />
  );
};
